import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../core/actions/actions';
import { FormattedMessage, injectIntl } from 'react-intl';
import { formatMessage } from '../../translations/connectedIntlProvider';
import Loader from '../../shared/components/Loader/Loader';
import Grid from '../../shared/components/Grid/Grid';
import { ButtonFormatter, EditFormatter, ChangePasswordFormatter } from '../../shared/components/Grid/GridFormatter';
import { faTrashAlt, faKey, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { allUsers } from '../../core/selectors/user.selector';
import IState from '../../core/models/IState';
import AddUserPopupHOC from './hoc/AddUserPopupHOC';
import { toast } from 'react-toastify';
import DeletePopup from '../../shared/components/Popup/DeletePopup';
import ChangePasswordPopup from '../Auth/ChangePasswordPopup';
import AddUser from './AddUser';
import './User.css';
import DeletePopupHOC from '../../shared/components/Popup/hoc/DeletePopupHOC';
import Pagination from "../../shared/components/Grid/Pagination";
import IPageInfo from '../../models/IPageInfo';
import IPageLimit from '../../models/IPageLimit';
import ChangePasswordPopupHOC from '../Auth/hoc/ChangePasswordPopupHOC';
import userIcon from '../../assets/Images/user32.png';
import useWindowDimensions from '../../helpers/windowResize.helper';
import NoDataComponent from '../../shared/components/NoData/NoDataComponent';
import UserIcon from '../../assets/Images/icon/svg/user-icon.svg'

const User = (props: any) => {
  /* eslint-disable jsx-a11y/anchor-is-valid */
  const [selectedId, setSelectedId] = useState<number>(0);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);

  const dispatch = useDispatch();
  const { userList, deleteUser, addUser }: any = useSelector((state: IState) => { return state.user });
  const language = useSelector((state: IState) => { return state.preferences.language });
  const pager: IPageLimit = useSelector((state: IState) => { return state.pager });
  const allUsersData: any = useSelector(allUsers);
  const userType: any = useSelector((state: IState) => { return state.auth.userType });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false
  });

  const { height, width } = useWindowDimensions();

  var windowHeight = width > 767 ? {
    maxHeight: height - 80
  } : {
    maxHeight: height - 125
  };


  useEffect(() => {
    dispatch(actions.getPageLimit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const GetAllUsers = (currentPage: number, pagerSize: number) => {
    setDisablePagination(true);
    if (userType === 'Administrator')
      dispatch(actions.getAllUser(currentPage, pagerSize, true));
    else
      dispatch(actions.getAllUser(currentPage, pagerSize, false));
  }

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  }

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  }

  const onPageLimitChanged = (evt: any) => {
    let pages: number
    pages = props.data && Math.ceil(props.data.length / evt.target.value)
    setPageInfo({ ...pageInfo, currentPage: 1, totalPages: pages, isPagerChange: false });
    dispatch(actions.updatePagerPageLimit(evt.target.value));
  }

  const refreshUserClickHandler = () => {
    if (pager.isPageLimitLoaded) {
      GetAllUsers(pageInfo.currentPage, pager.pageLimit);
    }
  }

  useEffect(() => {
    refreshUserClickHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  useEffect(() => {
    if (!userList.loading && userList.users.Users !== undefined && userList.users.Users.length >= 0) {
      setPageInfo({ ...pageInfo, totalPages: userList.users.TotalPages });
      setDisablePagination(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userList.loading])

  useEffect(() => {
    if (pager.isPageLimitLoaded) {
      GetAllUsers(pageInfo.currentPage, pager.pageLimit);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pager.isPageLimitLoaded, pager.pageLimit]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      GetAllUsers(pageInfo.currentPage, pager.pageLimit);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (deleteUser.success) {
      toast.success(formatMessage('Message_User_Delete_Success'));
      dispatch(actions.resetDeleteUserState());
      props.deletePopupToggleHandler();
      GetAllUsers(pageInfo.currentPage, pager.pageLimit);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteUser.success]);

  useEffect(() => {
    if (deleteUser.error != null)
      toast.error(formatMessage(deleteUser.error));
    dispatch(actions.resetDeleteUserState());
    // eslint-disable-next-line react-hooks/exhaustive-deps  
  }, [deleteUser.error]);

  useEffect(() => {
    if (userList.error != null)
      toast.error(formatMessage(userList.error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userList.error]);

  useEffect(() => {
    if (addUser.success) {
      GetAllUsers(pageInfo.currentPage, pager.pageLimit);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUser.success]);

  const openAddUserHandler = (row: any, isDeleteParam: boolean) => {
    setSelectedId(row.id);
    setIsDelete(isDeleteParam);
    props.addUserToggleHandler();
    //console.log(userType == 'Administrator');
  }

  const deleteHandler = () => {
    dispatch(actions.deleteUser(selectedId));
  }

  const deleteClickHandler = (row: any) => {
    setSelectedId(row.id);
    props.deletePopupToggleHandler();
  }

  const changePasswordClickHandler = (row: any) => {
    setSelectedId(row.id);
    props.changePasswordPopupToggleHandler();
  }

  const columns: any[] = [{
    dataField: 'id',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'UserName',
    text: formatMessage('User_Label_LoginId')
  }, {
    dataField: 'UserType',
    text: formatMessage('User_Table_Col_UserType')
  }, {
    dataField: 'edit',
    formatter: EditFormatter(openAddUserHandler, faPencilAlt, true, formatMessage('Edit')),
    text: ''
  }
    , {
    dataField: 'delete',
    formatter: ButtonFormatter(deleteClickHandler, faTrashAlt, true, formatMessage('Delete')),
    text: ''
  }, {
    dataField: 'changePassword',
    formatter: ChangePasswordFormatter(changePasswordClickHandler, faKey, true, formatMessage('Change_Password')),
    text: ''

  }];

  return (
    <React.Fragment>
      {
        props.showAddUserPopup &&
        <AddUser
          id={selectedId}
          isDelete={isDelete}
          modalClosed={props.addUserToggleHandler} />
      }
      {
        props.showDeletePopup &&
        <DeletePopup
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          isLoading={deleteUser.loading} />
      }
      {
        props.showChangePasswordPopup &&
        <ChangePasswordPopup
          id={selectedId}
          modalClosed={props.changePasswordPopupToggleHandler}
          isAdmin={true} />
      }

      <div className="icon-nav navbar-fixed-top device-nav-bar">
        <div className="container-fluid">
          <div className="filter-left-area">
            <ul>
              <li><h1><img src={userIcon} alt=""></img> <FormattedMessage id='User_Title' /></h1></li>
            </ul>
          </div>

          <div className="add-list float-right">
            <ul>
              {userType === 'Administrator' &&
                <li title={formatMessage('Add_User')}>
                  <a data-toggle="modal" onClick={() => openAddUserHandler({ id: -1 }, false)} data-target="#addUser">
                    <svg width="23" height="23" fill="#747474" className="bi bi-plus" viewBox="0 0 16 16">
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                  </a>
                </li>
              }
              <li className="page-number">
                <Pagination isRefreshPage={false} totalPages={pageInfo.totalPages} pageLimit={pager.pageLimit} onPageChanged={onPageChanged} disablePagination={disablePagination} setIsRefreshPage={setIsRefreshPage} />
              </li>
              <li className="page-count-no">
                <select className='pageLimit' onChange={onPageLimitChanged} value={pager.pageLimit}>
                  {pager.pageLimitOptions.map((op: any) => <option key={op} value={op}>{op}</option>)}
                </select>
              </li>
            </ul>
          </div>
        </div>
      </div>


      <div className="container">
        <div className="device-detail">
          <div className="table-responsive" style={windowHeight}>
            {userList.loading ? (<Loader />) : allUsersData.length === 0 ? (
              <NoDataComponent image={UserIcon} message={'No_User_Available'} imageAlt={'No User'} />
              ) : (
              <Grid data={allUsersData} columns={columns} keyField="id" />
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default injectIntl(AddUserPopupHOC(DeletePopupHOC(ChangePasswordPopupHOC(User))));